export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://hurley-associates.com/web/images/logo21t.gif" 
              alt="Frank T. Hurley Associates, Inc." 
              className="h-16 w-auto mb-6"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Three generations of trusted real estate service in St. Pete Beach, Florida.
            </p>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('listings')} className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Listings
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">Real Estate Sales</li>
              <li className="text-sm text-gray-400">Vacation Rentals</li>
              <li className="text-sm text-gray-400">Annual Leases</li>
              <li className="text-sm text-gray-400">Property Management</li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">
                2506 Pass-a-Grille Way<br />
                St. Pete Beach, FL 33706
              </li>
              <li>
                <a href="tel:727-367-1949" className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Phone: 727-367-1949
                </a>
              </li>
              <li className="text-sm text-gray-400">
                Fax: 727-367-1304
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400">
              © 2026 Frank T. Hurley Associates, Inc. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="nofollow noopener noreferrer" 
              className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}